<template>
  <div class="reset-password-wrapper d-flex">
    <!-- Right Section: Form Content -->
    <div class="right-section d-flex flex-column justify-content-center align-items-center">
      <div class="password-wrap card border-0 text-dark">
        <!-- Step 1: Send Verification -->
        <form v-if="!showStep2" @submit.prevent="sendVerificationToken" class="form-content shadow-sm p-4 rounded">
          <div class="col-12 text-center mb-4">
            <h4 class="fs-2 fw-bold text-dark">Ξεχάσατε τον κωδικό σας;</h4>
            <p class="text-dark">
              Εισαγάγετε τη διεύθυνση email που χρησιμοποιήσατε κατά την εγγραφή σας και θα σας στείλουμε οδηγίες για να επαναφέρετε τον κωδικό πρόσβασής σας.
            </p>
          </div>
          <div class="col-12 mb-3">
            <label class="form-label fw-bold">Email</label>
            <input type="email" class="form-control" v-model="email" placeholder="name@example.com" required />
          </div>
          <div class="col-12 text-center mt-4">
            <button
              type="submit"
              class="btn btn-primary fw-bold text-uppercase px-4 py-2"
              :disabled="loading"
            >
              Αποστολή
            </button>
          </div>

         

          <!-- Error/Success Messages -->
          <div v-if="errorMessage" class="alert alert-danger text-center mt-3">
            {{ errorMessage }}
          </div>
          <div v-if="successMessage" class="alert alert-success text-center mt-3">
            {{ successMessage }}
          </div>
        </form>

        <!-- Step 2: Change Password -->
        <form v-if="showStep2" @submit.prevent="completePasswordChange" class="form-content shadow-sm p-4 rounded">
          <div class="col-12 text-center mb-4">
            <h3 class="fs-2 fw-bold text-uppercase">Αλλαγή Κωδικού</h3>
            <p class="text-dark">Εισάγετε τον νέο σας κωδικό πρόσβασης.</p>
          </div>
          <div class="col-12 mb-3">
            <label class="form-label fw-bold">Νέος κωδικός</label>
            <input
              type="password"
              class="form-control"
              v-model="password"
              placeholder="********"
              required
            />
          </div>
          <div class="col-12 mb-3">
            <label class="form-label fw-bold">Επιβεβαίωση νέου κωδικού</label>
            <input
              type="password"
              class="form-control"
              v-model="passwordConfirmation"
              placeholder="********"
              required
            />
          </div>
          <div class="col-12 text-center mt-4">
            <button
              type="submit"
              class="btn btn-primary fw-bold text-uppercase px-4 py-2"
              :disabled="loading"
            >
              Αλλαγή
            </button>
          </div>

        

          <!-- Error/Success Messages -->
          <div v-if="errorMessage" class="alert alert-danger text-center mt-3">
            {{ errorMessage }}
          </div>
          <div v-if="successMessage" class="alert alert-success text-center mt-3">
            {{ successMessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

  
<script>
import { ref, onMounted } from 'vue';
import apiClient from '@/services/api';
import { getAppInfo } from '@/services/appInfo.js';
import { useRouter } from 'vue-router';

export default {
  name: 'ResetPassword',
  setup() {
    const router = useRouter();
    const email = ref('');
    const password = ref('');
    const passwordConfirmation = ref('');
    const token = ref('');
    const loading = ref(false);
    const errorMessage = ref('');
    const successMessage = ref('');
    const showStep2 = ref(false);
    const appInfo = ref(null);

    onMounted(async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const emailParam = urlParams.get('email');
      const tokenParam = urlParams.get('token');
      try {
        const info = await getAppInfo();
        appInfo.value = info.data.success ? info.data.data : false;
      } catch (e) {
        errorMessage.value = 'Failed to load app info';
      }

      if (emailParam && tokenParam) {
        email.value = emailParam;
        token.value = tokenParam;
        showStep2.value = true;
      }
    });

    const sendVerificationToken = async () => {
      loading.value = true;
      errorMessage.value = '';
      successMessage.value = '';
      try {
        const response = await apiClient.post('send-verification-token', { email: email.value });
        if (response.data.success) {
          successMessage.value = response.data.message;
        } else {
          errorMessage.value = response.data.message;
        }
      } catch (error) {
        errorMessage.value = 'An error occurred while sending the verification token.';
      } finally {
        loading.value = false;
      }
    };

    const completePasswordChange = async () => {
      loading.value = true;
      errorMessage.value = '';
      successMessage.value = '';
      try {
        const response = await apiClient.post('complete-password-change', {
          email: email.value,
          token: token.value,
          password: password.value,
          password_confirmation: passwordConfirmation.value,
        });
        if (response.data.success) {
          successMessage.value = response.data.message;
          setTimeout(() => {
            window.location.href = '/';
          }, 2000);
        } else {
          errorMessage.value = response.data.message;
        }
      } catch (error) {
        errorMessage.value = 'An error occurred while changing the password.';
      } finally {
        loading.value = false;
      }
    };

    const goToRegisterBusinessPartner = () => {
      router.push('/business-partner-request');
    };

    const goToLogin = () => {
      router.push('/login');
    };

    return {
      email,
      password,
      passwordConfirmation,
      loading,
      errorMessage,
      successMessage,
      showStep2,
      sendVerificationToken,
      completePasswordChange,
      appInfo,
      goToRegisterBusinessPartner,
      goToLogin,
    };
  },
};

  </script>
  
  <style scoped>
  
  .button-group {
    display: flex;
    align-items: center; 
    justify-content: center; 
  } 
  
  .button-group span {
    margin: 0 10px; 
    font-size: 1.2rem;
  }

  .reset-password-wrapper {
    height: 70vh; 
    display: flex;
    justify-content: center;
    align-items: stretch;
  }

  .Loginlogo{
    height: 200px;
  }

  .left-section {
    background-color: rgb(240, 240, 240);
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .right-section {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
  }
  
  .form-container {
    width: 100%;
    max-width: 450px;
  }
  
  .form-control-md {
    width: 100%;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  }
  
  .error-div {
    color: red;
    text-align: center;
  }

  .loginTitle{
    text-shadow: 2px 0px;
  }

  .success-message {
    color: rgb(64, 168, 64);
    text-align: center;
  }

  .password-wrap{
    width: 460px;
    max-width: 100%;
  }
  
  @media (max-width: 768px) {
    .reset-password-wrapper {
      flex-direction: column;
      height: unset !important;
      justify-content: start;
    }
    .Loginlogo{
      height: 160px;
    }
    .left-section,
    .right-section {
      width: 100%;
    }
  }
  </style>
  